export default __webpack_public_path__ + "ec1d1471d629529997b568e4361f1708.png";